import Attention from '$components/Attention/Attention';
import { LayoutContext } from '$root/src/context';
import cn from 'classnames';
import { HTMLAttributes, useContext, useRef } from 'react';

import { IOverlayButton, OverlayButtonSize } from './';

const sizeClasses: Record<OverlayButtonSize, string> = {
  l: 'w-14 h-14',
  s: 'w-12 h-12',
};

/*const typeClasses: Record<OverlayButtonType, string> = {
  light: 'bg-black',
  dark: 'bg-white',
};
const innerTypeClasses: Record<OverlayButtonType, string> = {
  light: 'bg-white',
  dark: 'bg-black',
};*/

export function OverlayButton(
  props: IOverlayButton & HTMLAttributes<HTMLElement>,
) {
  const { className, size, action, title } = props;

  const useLayoutStore = useContext(LayoutContext);

  const overlayContentOpen = useLayoutStore(
    (state) => state.overlayContentOpen,
  );

  const ref = useRef(null);

  const onClick = (e) => {
    action(e);
  };
  return (
    <>
      <div className={cn('flex flex-col')}>
        <Attention />
        <button
          title={title}
          ref={ref}
          className={cn(
            sizeClasses[size],
            //typeClasses[type],
            className,
            'circle-plus closed flex justify-center items-center text-center duration-300 relative',
            overlayContentOpen ? 'opened' : '',
            `bg-black text-white font-bold rounded-full
            hover:bg-50 dark:hover:bg-50
            dark:bg-white
            active:bg-50
            disabled:text-grey-40 disabled:border-0 disabled:bg-grey-20
            focus:outline focus:outline-6 focus:outline-grey-20
            [&>div>div]:hover:!bg-white  [&>div>div]:dark:hover:!bg-white [&>div>div]:dark:!bg-black [&>div>div]:!bg-white`,
          )}
          onClick={onClick}
        >
          <div className={cn('circle w-4 h-4 rounded-full relative')}>
            <div
              className={cn(
                //innerTypeClasses[type],
                'left-[50%] top-[50%] absolute horizontal',
              )}
            ></div>
            <div
              className={cn(
                //innerTypeClasses[type],
                'left-[50%] top-[50%] absolute vertical',
              )}
            ></div>
          </div>
        </button>
      </div>
    </>
  );
}
